<template>
  <div class="ibox float-e-margins mass-panel mass-selection-panel">
    <div class="ibox-title">
      <h5>{{ labels.selectedOrder }}</h5>
      <span class="mass-count-badge pull-right">{{ selectedIds.length }}</span>
    </div>
    <div class="ibox-content p-none">
      <draggable v-model="selectedConfigsOrdered" class="list-group mass-selected-list">
        <div v-for="config in selectedConfigsOrdered" :key="config.id" class="list-group-item"
             style="cursor: move; border-left: 0; border-right: 0;">
          <span class="mass-drag-handle"><i class="fa fa-bars"></i></span>
          <span class="mass-selected-copy">
            <span class="mass-selected-primary">{{ config.internal_name || config.app_name }}</span>
            <span class="mass-selected-meta">
              <span>{{ config.app_name || '-' }}</span>
              <span>App ID: {{ config.app_id || '-' }}</span>
            </span>
          </span>
          <button class="btn btn-xs btn-link pull-right text-danger mass-remove-button"
                  @click="$emit('remove', config.id)">
            <i class="fa fa-times"></i>
          </button>
        </div>
      </draggable>
      <div v-if="selectedConfigsOrdered.length === 0" class="mass-empty-state">
        {{ labels.noAppsSelected }}
      </div>
    </div>
  </div>
</template>

<script>
import draggable from 'vuedraggable';

export default {
  components: {
    draggable,
  },
  props: {
    labels: {
      type: Object,
      required: true,
    },
    configurations: {
      type: Array,
      required: true,
    },
    selectedIds: {
      type: Array,
      required: true,
    },
  },
  computed: {
    selectedConfigsOrdered: {
      get() {
        return this.selectedIds.map(id => this.configurations.find(c => c.id === id)).filter(Boolean);
      },
      set(newList) {
        this.$emit('update-selected-ids', newList.map(c => c.id));
      },
    },
  },
};
</script>
